var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.980684 39.5193C-0.326894 38.2117 -0.326894 36.0721 0.980684 34.7645L34.2645 1.48068C35.5721 0.173106 37.7117 0.173106 39.0193 1.48068C40.3269 2.78826 40.3269 4.92793 39.0193 6.23551L5.73551 39.5193C4.42793 40.8269 2.28826 40.8269 0.980684 39.5193Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2645 39.5193L0.980684 6.23551C-0.326894 4.92793 -0.326894 2.78826 0.980684 1.48068C2.28826 0.173106 4.42793 0.173106 5.73551 1.48068L39.0193 34.7645C40.3269 36.0721 40.3269 38.2117 39.0193 39.5193C37.7117 40.8269 35.5721 40.8269 34.2645 39.5193Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.52ab58b5b80a19fd9cba02de93ac72d6.svg";
export { ForwardRef as ReactComponent };